define('views/modules/calendar/animated-session/custom-exercises-manager/custom-exercises-manager-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/animated-session/custom-exercises-manager/custom-exercises-manager-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VCustomExercisesManagerContent
) {

    var VCustomExercisesManagerPanel = VBasePanel.extend({
        header: {
            title: "calendar:Custom exercises",
            subtitle: "calendar:Adding/Modify a custom exercise",
        },
        tabs: [{ id: 'manage', title: 'Manage', icon: 'sl-icon-settings', active: true }],
        content: {
            manage: VCustomExercisesManagerContent
        },
        defaultView: 'manage',

        initialize: function(opt) {
            opt = opt || {};
            var manage = this.getView('manage', {
                model: this.model,
                group: opt.group,
            });
        },
    });

    return VCustomExercisesManagerPanel;
});

